import { Injectable, ComponentFactoryResolver, ViewContainerRef, Renderer } from '@angular/core';
import { StsBsDialogComponent } from 'app/components/common/sts-bs-dialog/sts-bs-dialog/sts-bs-dialog.component';
import StsLink from '../models/sts-link.model';

@Injectable()
export class StsDialogFactoryService {

  constructor() { }

  createDialog(compResolver: ComponentFactoryResolver,
    container: ViewContainerRef,
    document: any,
    renderer: Renderer) {

    let links: any = document.querySelectorAll('.ariel-sts-iframe');
    if (!links) {
      return;
    }
    let factory = compResolver.resolveComponentFactory(StsBsDialogComponent);

    for (let link of links) {
      if (link.already) { continue; }
      link.already = true;
      let iFrameSrc = link.getAttribute('data-src');

      // if component has <ng-content> element for transclusion of inner html,
      // then dynamically created component will not get inner html,
      // since factory knows only components constructor class, and no idea about markup added somewhere as inner html.
      // To transclude, we have to pass inner html nodes explicitly.

      let myNode = document.createElement('iframe');
      myNode.src = iFrameSrc;
      myNode.className = 'dialog-iframe';
      myNode.width = '100%';
      myNode.frameborder = '0';

      let component = container.createComponent(factory, 0, container.parentInjector, [[myNode]]);
      component.instance.visible = false;
      component.instance.useIFrame = true;
      component.instance.item = new StsLink();
      component.instance.item.title = link.innerHTML;
      component.changeDetectorRef.detectChanges();

      container.insert(component.hostView);
      renderer.listen(link, 'click', (event) => {
        event.preventDefault();
        component.instance.visible = true;
      });

    }
  }
}
